import { UnitSizes } from './../../models/unitSizes';
import { PageSettings } from './../../models/pageSettings';
import { Component, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { isNullOrUndefined, isUndefined } from "util";
import "rxjs/add/operator/toPromise";
import { MdCheckboxChange } from '@angular/material';
declare const swal: any;

@Component({
  selector: 'app-size-guide',
  templateUrl: './size-guide.component.html',
  styleUrls: ['./size-guide.component.scss']
})
export class SizeGuideComponent implements OnInit {

  key: string;
  unitSizes: any;
  locationData: LocationInfo;
  clientData: Client;
  showSaveButton = false;
  pageSettings: PageSettings;

  selectedLocation: any;
  locations: any;
  selectedLocationSizesToAdd = {};

  sizeIndex = {};
  locationIndex = {};
  basedOn: any;
  unitSize: UnitSizes;

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];

      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        this.locations = this.afService.getLocations(this.clientData);
        this.afService.loadPageSettings(this.key).subscribe((data) => {
          if (isUndefined(data.$value)) {
            this.pageSettings = data;
          }
        });

        if (!this.clientData.suppressGetUnits) {
          this.afService.getAllUnitSizes(this.clientData.code).map(unitSizes => {
            let tmp = [];
            for (let i in unitSizes) {
              for (let index in unitSizes[i]) {
                if (unitSizes[i].hasOwnProperty(index)) {
                  var label = '';
                  var shortName = '';
                  if (unitSizes[i][index].length < unitSizes[i][index].width) {
                    label = `${ unitSizes[i][index].length } x ${ unitSizes[i][index].width }`;
                    shortName = `${ unitSizes[i][index].length }x${ unitSizes[i][index].width }`;
                  }
                  else {
                    label = `${ unitSizes[i][index].width } x ${ unitSizes[i][index].length }`;
                    shortName = `${ unitSizes[i][index].width }x${ unitSizes[i][index].length }`;
                  }
                  unitSizes[i][index].shortName = shortName;
                  tmp.push({ label: `${ label }`, value: this.getUnitSize(unitSizes[i][index], shortName), locationCode: i, shortName: shortName });
                }
              }
            }
            return tmp;
          }).subscribe(unitSizes => {
            this.unitSizes = unitSizes;
            for (let size of this.unitSizes) {
              console.log()
              if (isNullOrUndefined(this.sizeIndex[size.value.index])) {
                this.sizeIndex[size.value.index] = size.value;
              }
              if (isNullOrUndefined(this.locationIndex[size.locationCode])) {
                this.locationIndex[size.locationCode] = {};
              }
              this.locationIndex[size.locationCode][size.value.index] = true;
            }
            console.log(this.sizeIndex)
          });
        }
        else {
          this.unitSizes = [];
        }
      });
    });
  }

  copyFromPageSettings() {
    let pageSizesCopy = this.clientData.pages.sizeGuide.sizes;
    for (let copy of pageSizesCopy) {
      console.log(copy)
      this.locationData.sizeGuide.sizes.push(copy);
      if (!isNullOrUndefined(copy.name2) && copy.name2 !== '') {
        this.locationData.sizeGuide.sizes.push({ shortName: 'Copied from alt name', name: copy.name2, squareFeet: copy.squareFeet2 });
      }
    }
    this.showSaveButton = true;
  }

  updateShowButtons(e) {
    this.locationData.sizeGuide.hideButtons = e.checked;
    this.savelocationData();
  }

  toggleAllSizesLocation(e: MdCheckboxChange) {
    for (let i in this.selectedLocationSizesToAdd) {
      this.selectedLocationSizesToAdd[i] = e.checked;
    }
  }

  selectLocation(location) {
    this.selectedLocation = location;
    this.selectedLocationSizesToAdd = {};

    this.afService.getLocationSizeGuideSettingIndex(this.key, this.selectedLocation.$key).subscribe((data) => {
      console.log(Object.keys(data).length)
      console.log(data)
      if (Object.keys(data).length > 1) {
        for (let tmp in data) {
          delete data[tmp].$exists;
          delete data[tmp].$key;
          delete data[tmp].$value;
        }
        this.selectedLocationSizesToAdd = data;
      }
      else {
        for (let size of this.pageSettings.sizeGuide.sizes) {
          this.selectedLocationSizesToAdd[size.index] = false;
        }
      }
      console.log(this.selectedLocationSizesToAdd)
    })
  }

  updateLocationSizes() {

    console.log(this.selectedLocation)
    console.log(this.selectedLocationSizesToAdd)
    this.afService.updateLocationSizeGuideSettingIndex(this.key, this.selectedLocation.$key, this.selectedLocationSizesToAdd).then(() => {
      this.afService.openSnackBar('Size Guide Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    })
  }

  addLocationSize(e) {
    console.log(e)
    // this.selectedLocation.sizeGuideSizes[shortName] = true;
    // console.log(this.selectedLocation.sizeGuideSizes)
  }

  savelocationData() {
    for (let tmp of this.locationData.sizeGuide.sizes) {
      delete tmp._$visited;
    }
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.openSnackBar('Location Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  savePageSettings() {
    this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
      this.afService.openSnackBar('Page Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  async fillSizeData() {
    swal({
      title: "Are you sure?",
      text: "This will replace anything currently there.",
      icon: "warning",
      buttons: true,
      dangerMode: true
    })
      .then((confirm) => {
        if (confirm) {

          var data = [];
          for (let key in this.sizeIndex) {
            data.push(this.sizeIndex[key]);
          }
          data.sort(function (a, b) { return a.squareFeet - b.squareFeet })
          this.afService.updateSizeGuideSetting(this.key, data).then(() => {

            // this.afService.updateSizeGuideSettingIndex(this.key, this.sizeIndex).then(() => {
            this.afService.openSnackBar('Page Settings Updated Successfully');
            // })
            //   .catch(e => {
            //     this.afService.openSnackBar(e.message);
            //   });
            this.afService.openSnackBar('Page Settings Updated Successfully');
          })
            .catch(e => {
              this.afService.openSnackBar(e.message);
            });
        }
      });

  }

  async fillSizeDefaultData() {
    swal({
      title: "Are you sure?",
      text: "This will replace anything currently there.",
      icon: "warning",
      buttons: true,
      dangerMode: true
    })
      .then((confirm) => {
        if (confirm) {

          var data = [];
          data = [{
            "cc": true,
            "description": "Personal items, clothes, boxes, skis, children's toys, small furniture items, business records, and sales rep materials.",
            "equivalent": "Regular closet",
            "img": "assets/images/55.png",
            "index": "500x500",
            "name": "Self Storage",
            "shortName": "5x5",
            "squareFeet": 25
          }, {
            "cc": true,
            "description": "Small amounts of furniture, sofas, chairs, chest of drawers, boxspring and mattress, business supplies and records, plus other small items and boxes.",
            "equivalent": "Walk-in closet",
            "img": "assets/images/105.png",
            "index": "1000x500",
            "name": "Self Storage",
            "shortName": "5x10",
            "squareFeet": 50
          }, {
            "cc": true,
            "description": "One-bedroom apartment with major appliances, other furniture, and supplies.",
            "equivalent": "Half of a one-car garage",
            "img": "assets/images/1010.png",
            "index": "1000x1000",
            "name": "Outdoor Self Storage",
            "shortName": "10x10",
            "squareFeet": 100
          }, {
            "cc": true,
            "description": "A two-bedroom apartment or house, including appliances, boxes and miscellaneous items, and commercial storage inventory.",
            "equivalent": "Two-thirds of a one-car garage",
            "img": "assets/images/1015.png",
            "index": "1500x1000",
            "name": "Climate",
            "shortName": "10x15",
            "squareFeet": 150
          }, {
            "cc": true,
            "description": "A three-bedroom house with major appliances, plus lots of boxes. Business storage files and inventory ideal for storage racks.",
            "equivalent": "Standard one-car garage",
            "img": "assets/images/1025.png",
            "index": "2000x1000",
            "name": "Self Storage",
            "shortName": "10x20",
            "squareFeet": 200
          }]
          // for (let key in this.sizeIndex) {
          //   data.push(this.sizeIndex[key]);
          // }
          data.sort(function (a, b) { return a.squareFeet - b.squareFeet })
          this.afService.updateSizeGuideSetting(this.key, data).then(() => {

            // this.afService.updateSizeGuideSettingIndex(this.key, this.sizeIndex).then(() => {
            this.afService.openSnackBar('Page Settings Updated Successfully');
            // })
            //   .catch(e => {
            //     this.afService.openSnackBar(e.message);
            //   });
            this.afService.openSnackBar('Page Settings Updated Successfully');
          })
            .catch(e => {
              this.afService.openSnackBar(e.message);
            });
        }
      });
  }

  getUnitSize(unit, shortName) {
    var unitSize = new UnitSizes();
    unitSize.cc = unit.cc;
    unitSize.shortName = shortName;
    unitSize.name = unit.name;
    unitSize.img = this.getImage((unit.length * unit.width), shortName);
    unitSize.squareFeet = unit.length * unit.width;
    unitSize.index = (unit.length * 100) + 'x' + (unit.width * 100);
    unitSize.equivalent = this.getEquivalent(unit.length * unit.width);
    unitSize.description = this.getDescription(unit.length * unit.width);
    return unitSize;
  }

  getEquivalent(squareFeet) {
    if (squareFeet <= 25) {
      return 'Regular closet';
    }
    else if (squareFeet <= 50) {
      return 'Walk-in closet';
    }
    else if (squareFeet <= 100) {
      return 'Half of a one-car garage';
    }
    else if (squareFeet <= 150) {
      return 'Two-thirds of a one-car garage';
    }
    else if (squareFeet <= 200) {
      return 'Standard one-car garage';
    }
    else if (squareFeet <= 300) {
      return 'Standard two-car garage';
    }
    return '';
  }

  getImage(squareFeet, name) {
    if (name.indexOf('Parking') >= 0 || name.indexOf('parking') >= 0) {
      return 'assets/images/parking.png';
    }
    else if (squareFeet <= 25) {
      return 'assets/images/55.png';
    }
    else if (squareFeet <= 50) {
      return 'assets/images/105.png';
    }
    else if (squareFeet <= 120) {
      return 'assets/images/1010.png';
    }
    else if (squareFeet <= 170) {
      return 'assets/images/1015.png';
    }
    else if (squareFeet <= 250) {
      return 'assets/images/1025.png';
    }
    else if (squareFeet <= 325) {
      return 'assets/images/1030.png';
    }
    return 'assets/images/3010.png';
  }

  getDescription(squareFeet) {
    if (squareFeet <= 25) {
      return 'Personal items, clothes, boxes, skis, children\'s toys, small furniture items, business records, and sales rep materials.';
    }
    else if (squareFeet <= 50) {
      return 'Small amounts of furniture, sofas, chairs, chest of drawers, boxspring and mattress, business supplies and records, plus other small items and boxes.';
    }
    else if (squareFeet <= 100) {
      return 'One-bedroom apartment with major appliances, other furniture, and supplies.';
    }
    else if (squareFeet <= 150) {
      return 'A two-bedroom apartment or house, including appliances, boxes and miscellaneous items, and commercial storage inventory.';
    }
    else if (squareFeet <= 200) {
      return 'A three-bedroom house with major appliances, plus lots of boxes. Business storage files and inventory ideal for storage racks.';
    }
    else if (squareFeet <= 300) {
      return 'A four-to five-bedroom house with major appliances and room for boxes. Excellent for business storage of files, equipment, and permanent records.';
    }
    return '';
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/size-guide/size-guide.component.ts